<footer class="mt-auto py-3 bg-light" style="box-shadow: 2rem 0 1rem rgba(0, 0, 0, 0.15) !important;">
  <div class=" text-end pe-5">
    <span class="text-muted">© 2022 Hak Cipta Terpelihara LHDNM</span>
  </div>
</footer>